import { useState } from "react";
import { Product } from "@/data/products";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { ProductDetail } from "./ProductDetail";

interface ProductCardProps {
  product: Product;
}

export function ProductCard({ product }: ProductCardProps) {
  const { addToCart } = useCart();
  const [showDetail, setShowDetail] = useState(false);

  return (
    <>
      <div 
        onClick={() => setShowDetail(true)}
        className="group relative flex flex-col overflow-hidden rounded-[24px] bg-white border border-gray-100 shadow-[0_2px_10px_-4px_rgba(0,0,0,0.05)] transition-all hover:shadow-[0_20px_40px_rgba(0,0,0,0.08)] active:scale-[0.98] cursor-pointer"
      >
        <div className="aspect-[4/5] md:aspect-square overflow-hidden bg-[#FDFCFB] relative">
          <img
            src={product.images[0] || ""}
            alt={product.name}
            className="h-full w-full object-cover transition-all duration-700 group-hover:scale-105 group-hover:brightness-[0.97]"
          />
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-500" />
          <div className="absolute top-3 right-3">
            <Button
              size="icon"
              className="h-10 w-10 rounded-full bg-white/95 backdrop-blur-md text-pink-500 border-none shadow-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
              onClick={(e) => {
                e.stopPropagation();
                setShowDetail(true);
              }}

            >
              <Plus className="h-5 w-5" />
            </Button>
          </div>
        </div>
        <div className="flex flex-1 flex-col p-4">
          <h3 className="mb-1 text-base font-semibold text-gray-800 leading-tight line-clamp-2">{product.name}</h3>
          <div className="mt-auto flex items-center justify-between gap-2">
            <span className="text-lg font-bold text-pink-600">
              {new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(product.price)}
            </span>
          </div>
        </div>
      </div>

      <ProductDetail 
        product={product} 
        open={showDetail} 
        onOpenChange={setShowDetail} 
      />
    </>
  );
}
